import './contentModalCalculPerformance.css';
import type { JSX } from 'react';

interface ModalCalculPerformanceProps {
  priseEnCompte?: boolean;
  equation?: boolean;
  PMV?: boolean;
  titrePopin?: string;
  titreExplicationPopin?: string | JSX.Element;
  explicationPopin?: string | JSX.Element;
  titreExplication1?: string;
  explication1?: string;
  titreExplication2?: string;
  explication2?: string;
  paragraphe?: string;
  titrePerformance?: string;
  numerateurEquation?: string;
  denominateurEquation?: string;
  paragrapheSousEquation?: string;
}

const ContentModalCalculPerformance = ({
  priseEnCompte,
  equation,
  PMV,
  titrePopin,
  titreExplicationPopin,
  explicationPopin,
  titreExplication1,
  explication1,
  titreExplication2,
  explication2,
  paragraphe,
  titrePerformance,
  numerateurEquation,
  denominateurEquation,
  paragrapheSousEquation,
}: ModalCalculPerformanceProps): JSX.Element => {
  const lignes = explication1?.split('\n');
  const paragrapheExplication1 = lignes?.map((ligne) => (
    <p style={{ marginBottom: 10 }} key={ligne}>
      {ligne}
    </p>
  ));

  return (
    <div className="calcul-performance-contrat">
      <h2 className="center-text">{titrePopin}</h2>

      {PMV && (
        <div className="calcul-performance-contrat-bloc-PVM">
          <p className="color-text-PVM">PLUS OU MOINS VALUE EN EUROS (PMV) =</p>
          <p className="color-text-PVM">Valeur à date - versement initial + remboursements + réduction fiscale</p>
        </div>
      )}

      <div>
        {titreExplicationPopin && <h3>{titreExplicationPopin}</h3>}
        <p>{explicationPopin}</p>
      </div>

      {equation && (
        <div className="calcul-performance-contrat-bloc-performance">
          <div>
            <p>{titrePerformance}</p>
          </div>
          <div className="calcul-performance-contrat-calcul">
            <div>
              <p>{numerateurEquation}</p>
              <span className="line-equation-performance"></span>
              <p>{denominateurEquation}</p>
            </div>
            <span>-1</span>
          </div>
        </div>
      )}

      {priseEnCompte && (
        <>
          {paragrapheSousEquation && <p className="color-explication-popin">{paragrapheSousEquation}</p>}

          <div>
            <h3>{titreExplication1}</h3>
            <p>{paragrapheExplication1}</p>
          </div>

          <div>
            <h3>{titreExplication2}</h3>
            <p>{explication2}</p>
          </div>

          <p>{paragraphe}</p>
        </>
      )}
    </div>
  );
};

export default ContentModalCalculPerformance;
